module.exports = __webpack_public_path__ + "img/button_locked_document.fd398adb.svg";